import {useCallback, useEffect, useState} from 'react';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import {deleteCard} from '../../../actions/zepzPayin/browser';

export const useZepzPayin = ({
    dispatch,
    csrfToken,
    initCards
}) => {
    const [cards, setCards] = useState(initCards || []);
    const [showForm, setShowForm] = useState(!cards.length);

    const toggleFormVisibility = useCallback(() => {
        setShowForm(!showForm);
    }, [showForm]);

    useEffect(() => {
        if (!cards.length) {
            setShowForm(true);
        }
    }, [cards]);

    const removeCard = useCallback(async ({id: cardId}) => {
        try {
            await deleteCard({cardId, csrfToken});

            const newCards = cards.filter(card => card.id !== cardId);

            setCards(newCards);
        } catch (e) {
            dispatch(genericErrorHasOccurred(true));
        }
    }, [cards]);

    return {
        cards,
        removeCard,
        showForm,
        toggleFormVisibility
    };
};
